<template>
  <v-card text>
    <!-- <v-toolbar color="primary" dark>
      <v-toolbar-title>Facebook audiences you've created</v-toolbar-title>
    </v-toolbar> -->
    <v-data-table
      :headers="headers"
      :items="files"
      :search="search"
      v-model="selected"
      item-key="id"
      :single-select="singleSelect"
      class="elevation-1"
      show-select
      sort-by="approximate_count"
      :sort-desc=true
      hide-default-footer
    >
      <template slot="headerCell" slot-scope="props">
        <span>
          {{ props.header.text }}
        </span>
      </template>
      <template slot="items" slot-scope="props">
<!--        <td>-->
<!--          <v-checkbox-->
<!--            :disabled="disableItem(props.item.id)"-->
<!--            color="green"-->
<!--            hide-details-->
<!--            v-model="props.selected"-->
<!--          />-->
<!--        </td>-->
        <td class="text-xs-left text-capitalize">{{ props.item.name | firstLetterCapitalize }}</td>
        <!-- <td class="text-xs-right">
          <v-tooltip bottom>
            <template v-slot:activator="{ on }">
              <span v-on="on">{{ dateFormat(props.item.time_created) }}</span>
            </template>
            <span>{{ dateFormatWithYear(props.item.time_created) }}</span>
          </v-tooltip>
        </td> -->
        <td class="text-xs-right text-capitalize" v-if="props.item.delivery_status">{{
          props.item.delivery_status.description | firstLetterCapitalize}}
        </td>
        <td class="text-xs-right text-capitalize" v-else> -</td>
        <td class="text-xs-right">{{ props.item.approximate_count | estimatedSize }}</td>
<!--        <td class="text-xs-right">-->

<!--          <v-btn-->
<!--            icon-->
<!--            small-->
<!--            class="mx-0"-->
<!--            :ripple="{ class: 'error&#45;&#45;text' }"-->
<!--            @click="dialog = true"-->
<!--          >-->
<!--            <v-icon-->
<!--              small-->
<!--              color="grey darken-1"-->
<!--            >close-->
<!--            </v-icon>-->
<!--          </v-btn>-->
<!--          <v-dialog-->
<!--            v-model="dialog"-->
<!--            max-width="290"-->
<!--          >-->
<!--            <v-card>-->
<!--              <v-card-text>-->
<!--                Are you sure you would like to delete this audience?-->
<!--              </v-card-text>-->
<!--              <v-card-actions>-->
<!--                <v-spacer></v-spacer>-->
<!--                <v-btn-->
<!--                  color="red darken-1"-->
<!--                  text="text"-->
<!--                  @click="dialog = false"-->
<!--                >-->
<!--                  Cancel-->
<!--                </v-btn>-->
<!--                <v-btn-->
<!--                  color="green darken-1"-->
<!--                  text="text"-->
<!--                  @click="removeFile(props.item.id)"-->
<!--                >-->
<!--                  Confirm-->
<!--                </v-btn>-->
<!--              </v-card-actions>-->
<!--            </v-card>-->
<!--          </v-dialog>-->
<!--        </td>-->
      </template>
      <template v-slot:item.action="{ item }">
        <v-dialog
          v-model="dialog"
          persistent
          max-width="290"
        >
          <template v-slot:activator="{ on }">
            <v-btn
              icon
              small
              class="mx-0"
              :ripple="{ class: 'error--text' }"
              v-on="on"
            >
              <v-icon
                small
                color="grey darken-1"
              >close
              </v-icon>
            </v-btn>
          </template>
          <v-card>
            <v-card-title>
              Are you sure you would like to delete this audience?
            </v-card-title>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn
                color="red darken-1"
                text
                @click="dialog = false"
              >
                Cancel
              </v-btn>
              <v-btn
                color="green darken-1"
                text
                @click="removeFile(props.item.id)"
              >
                Confirm
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </template>
    </v-data-table>
    <div class="text-xs-center pt-2">
      <v-pagination v-model="pagination.page" :length="pages" v-show="pages > 1"></v-pagination>
    </div>
  </v-card>
</template>

<script>
  import lodash from 'lodash'

  export default {
    name: 'files-table',
    data () {
      return {
        dialog: false,
        search: '',
        singleSelect: true,
        selected: [],
        headers: [
          {text: 'List', align: 'left', value: 'name'},
          // {text: 'Created', align: 'right', value: 'time_created'},
          {text: 'Status', align: 'right', value: 'delivery_status.description'},
          {text: 'Est. Size', align: 'right', value: 'approximate_count'},
          {text: 'Action', align: 'right', value: 'action', sortable: false}
        ],
        pagination: {
          sortBy: 'name',
          descending: true
        }
      }
    },
    props: {
      files: {
        type: Array,
        default: () => []
      },
      campaign: {
        type: Object,
        default: () => {}
      }
    },
    mounted () {
      if (this.campaign.targeting && this.campaign.targeting.custom_audiences) {
        const id = this.campaign.targeting.custom_audiences[0].id
        const selectedAudience = this.files.find(f => f.id === id)
        this.selected.push(selectedAudience)
      }
    },
    computed: {
      pages () {
        if (this.pagination.rowsPerPage == null ||
          this.pagination.totalItems == null
        ) {
          return 0
        }

        return Math.ceil(this.pagination.totalItems / this.pagination.rowsPerPage)
      },
      selectedAudience () {
        return this.$store.getters.getSelectedAudience
      }
    },
    filters: {
      firstLetterCapitalize (string) {
        return string.charAt(0).toUpperCase() + string.slice(1)
      },
      thousands (number) {
        if (isNaN(number)) return number
        return Number(number).toLocaleString()
      },
      estimatedSize (size) {
        if (size === -1) {
          return 'Facebook is determining audience size'
        } else if (size <= 1000) {
          return 'Audience size is < 1,000'
        } else {
          return Number(size).toLocaleString()
        }
      }
    },
    methods: {
      removeFile (id) {
        this.dialog = false
        this.$emit('removeFile', id)
      },
      dateFormat (date) {
        // if (!isNaN(date)) return this.$moment(date * 1000).format('MMM DD')
        return this.$moment(date).format('MMM DD')
      },
      dateFormatWithYear (date) {
        // if (!isNaN(date)) this.$moment(date * 1000).format('MMM DD, YYYY')
        return this.$moment(date).format('MMM DD, YYYY')
      },
      disableItem (id) {
        if (this.selected.length > 0) {
          if (this.selected.find(i => i.id !== id)) return true
        }
        return false
      }
    },
    watch: {
      selected (val) {
        if (val.length) {
          const targeting = {
            'custom_audiences': [{'id': this.selected[0].id}],
            'geo_locations': {'countries': ['US']}
          }
          this.$emit('setTargeting', targeting, true)
          this.$emit('setCampaignProperty', 'selectedAudiences', [{name: 'File Name', value: this.selected[0].name}])
        } else {
          this.$emit('setCampaignProperty', 'selectedAudiences', [])
          this.$emit('setTargeting', null, false)
        }
      },
      selectedAudience (val) {
        if (val) this.selected.push(lodash.cloneDeep(val))
      }
    }
  }
</script>
<style>
  .table tbody tr[active] {
    background: #a5d6a7 !important;
  }

  .text-capitalize {
    text-transform: capitalize;
  }
</style>
